import { Type } from 'class-transformer';
import { CollectionAsset } from './collection-asset';

export class Collection {
  @Type(() => Date) createdAt? = new Date();

  @Type(() => Date) modifiedAt? = new Date();

  @Type(() => CollectionAsset) assets: CollectionAsset[] = [];

  name = '';

  collectionId?: string;

  thumbnail: string;

  count = 0;

  ownerId?: string;

  constructor(values: Partial<Collection> = {}) {
    Object.assign(this, values);
  }
}
